import { render, staticRenderFns } from "./LongNovelWizard.vue?vue&type=template&id=6c96859f&scoped=true"
import script from "./LongNovelWizard.vue?vue&type=script&lang=js"
export * from "./LongNovelWizard.vue?vue&type=script&lang=js"
import style0 from "./LongNovelWizard.vue?vue&type=style&index=0&id=6c96859f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c96859f",
  null
  
)

export default component.exports